import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import "@/i18n";
import App from "@/App";

// Service Worker registration is handled inside <UpdateBanner /> via
// ``lib/updateChecker.registerServiceWorker`` — that wires the
// ``updatefound`` + ``controllerchange`` listeners needed to surface
// the "New version available" prompt. Keeping registration in one
// place avoids double-registration + duplicate reload cycles.

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

